export default __webpack_public_path__ + "static/qr-code-173d05376ff35fdad648dd50afc852f4.png";